import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-dashboard',
  templateUrl: './nav-dashboard.component.html',
  styleUrls: ['./nav-dashboard.component.scss']
})
export class NavDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
